import { render, staticRenderFns } from "./PeopleListItem.vue?vue&type=template&id=1dae9a5b&scoped=true&"
import script from "./PeopleListItem.vue?vue&type=script&lang=js&"
export * from "./PeopleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae9a5b",
  null
  
)

export default component.exports